import React, { useRef, useContext } from 'react';
import mod from './ChatAppForms.module.css';
import AuthContext from '../../context/auth-context';

function SelectUser(props) {
	const toUserRef = useRef();
	const authCtx = useContext(AuthContext);

	async function submitHandler(e) {
		e.preventDefault();
		const fromUser = authCtx.user;
		const toUser = toUserRef.current.value;
		const chatWithUser = {
			fromUser,
			toUser,
		};
		try {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/api/data/updateMessage`,
				{
					method: 'POST',
					headers: {
						'Content-type': 'application/json',
					},
					body: JSON.stringify(chatWithUser),
				}
			);
			const responseData = await response.json();
			if (!response.ok) {
				throw new Error(responseData.message);
			} else {
				props.SearchUser(
					toUser,
					responseData.message,
					responseData.lastUser
				);
				console.log(responseData);
			}
		} catch (e) {
			console.log(e);
		}
	}

	return (
		<form onSubmit={submitHandler} className={mod.selectUserContainer}>
			<label htmlFor='username'>Select User</label>
			<input
				type='text'
				id='username'
				ref={toUserRef}
				placeholder='Look for user'
			/>
			<button type='submit'>Search</button>
		</form>
	);
}

export default SelectUser;
